import { Subscription, SubscriptionRegistrationTokenSavedById } from 'graphql/generated/graphqlTypes';
import { generateMockSubscriptionRegistrationToken } from 'mocks/graphqlMocks/subscriptionRegistrationToken';

export function mockedOnRegistrationTokenSavedData(
  onRegistrationTokenSavedById: SubscriptionRegistrationTokenSavedById | null
): Pick<Subscription, 'onRegistrationTokenSavedById'> {
  return {
    onRegistrationTokenSavedById
  };
}

export const mockedOnRegistrationTokenSavedDataForSubscription = mockedOnRegistrationTokenSavedData(
  generateMockSubscriptionRegistrationToken({})
);
